export enum CTADeviceNames {
  desktop = 'desktop',
  mobile = 'mobile',
  nativeIOS = 'nativeIOS',
  nativeAndroid = 'nativeAndroid',
}

export enum NAVIGATION_TARGETS {
  BLANK = '_blank',
  SELF = '_self',
}

export enum CtaSectionType {
  CTA = 'CTA',
  OPTIN = 'Opt-in',
  EVENT = 'CTA-Event',
  SELECTIONS = 'Markets/Offers',
}

export enum ImageResolution {
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
}

/**
 * @deprecated
 *
 * Please use CTADeviceNames instead
 * This will be removed in the future
 */
export enum AdobeDeviceNames {
  desktop = 'desktop',
  mobile = 'mobile',
  tablet = 'tablet',
}
